import React, { useState } from 'react';
import { formatPriceWithEuro, truncate } from '../../utils/StringUtils';
import trash_icon from '../../styles/img/cart_delete.svg';
import { MidiDealCancelModal } from './MidiDealCancelModal';

const MidiDealCart = ({ midiDeal, orderItems, removeFromCartHandler }) => {
    const [itemToDelete, setItemToDelete] = useState(null);

    if (!midiDeal || !midiDeal.isActive || midiDeal.items?.length !== 3) return null;

    const { dealPrice, originalPrice, items } = midiDeal;
    const savings = midiDeal?.savings || 0;

    const handleConfirmDelete = (e) => {
        if (itemToDelete) {
            removeFromCartHandler(e, [{ product: itemToDelete, qty: 1 }]);
            setItemToDelete(null);
        }
    };

    const handleDeleteClick = (e, item) => {
        e.stopPropagation();
        const orderItem = orderItems?.find(oi => oi.Code_Barre === item.barcode);
        if (orderItem && orderItem.Qty > 1) {
            removeFromCartHandler(e, [{ product: orderItem, qty: 1 }]);
        } else {
            setItemToDelete(orderItem || item);
        }
    };

    return (
        <div className="w-full bg-gradient-to-b mt-4 from-[#ffde5920] to-[#f19e1033] rounded-3xl pt-4 pb-2 px-1 mb-4">
            <div className="flex justify-between items-center mb-3">
                <span className="geomanistMedium ml-4 text-[16px] text-[#0E0B26]">Midi Deal</span>
                <div className="flex items-center gap-2 mr-4">
                    <span className="geomanistMedium text-[16px] text-zinc-400 line-through ">
                        {formatPriceWithEuro(originalPrice)}
                    </span>
                    <span className="relative geomanistBold text-[20px]" style={{ letterSpacing: "2px" }}>
                        <span
                            className="absolute inset-0"
                            style={{
                                WebkitTextStroke: "3px #C89825",
                                color: "transparent"
                            }}
                        >{formatPriceWithEuro(dealPrice)}</span>
                        <span
                            style={{
                                background: "linear-gradient(107.64deg, #f3d349ff 64.66%, #F19F10 100.98%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                backgroundClip: "text",
                                position: "relative",
                                filter: "drop-shadow(1px 2px 0px #C89825)"
                            }}
                        >{formatPriceWithEuro(dealPrice)}</span>
                    </span>
                </div>
            </div>

            <div className="flex flex-col gap-0 bg-white rounded-3xl overflow-hidden border border-4 border-[#9f8c411f]">
                {items.map((item, index) => (
                    <div key={item.id || index} className="flex rounded-none items-center p-3 border border-l-0 border-r-0 border-b-1 border-[#f6dc4b4a] last:border-b-0">
                        <div className="w-[61px] h-[61px] flex-shrink-0 mr-3">
                            <img
                                src={item.image}
                                alt={item.title}
                                className="w-full h-full object-contain"
                            />
                        </div>

                        <div className="flex-grow flex flex-col justify-center">
                            <span className="geomanistBook text-[12px] text-[#0E0B26] leading-tight">
                                {truncate(item.title, 25)}
                            </span>
                            <span className="geomanistMedium text-[14px] text-zinc-400 line-through decoration-gray-800">
                                {formatPriceWithEuro(item.originalPrice)}
                            </span>
                        </div>

                        <button
                            type="button"
                            onClick={(e) => handleDeleteClick(e, item)}
                            className="p-2"
                        >
                            <img src={trash_icon} alt="delete" className="w-6 h-6" />
                        </button>
                    </div>
                ))}
            </div>

            <MidiDealCancelModal
                open={!!itemToDelete}
                onClose={() => setItemToDelete(null)}
                onConfirm={handleConfirmDelete}
                savings={formatPriceWithEuro(savings)}
            />
        </div>
    );
};

export default MidiDealCart;
